var _rect, _rect2, _g, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.748047,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#DCEAFF",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 2,
    y: 2.74805,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3638_152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.993 12.573L17.168 11.748L14.168 14.748L11.168 17.748L14.168 20.748L17.168 23.748L17.993 22.923L18.8203 22.0957L16.6477 19.923L14.4727 17.748L16.6477 15.573L18.8203 13.4004L17.993 12.573Z",
    fill: "#2E2E2E",
    fillOpacity: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.74805,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#2E2E2E",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3638_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(0 1 -1 0 21 11.748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/LeftButton.e4d5c1e623f79776536312a38add5886.svg";
export { ForwardRef as ReactComponent };